<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>
<script>
import {
  getList,
	add,
	uploadFile,
} from "@/api/order/DeliveryAgentSwitch";
import cTable from "@/base/common/index";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
import { getAgent } from "@/api/tracker/agent";
// import { getAllClient } from "@/api/user/client";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
export default {
  name: "DeliveryAgentSwitch",
	components:{
		cTable
	},
  async created() {
		let agentList = (await getAgent()).data.payload.rows
		this.header.searchs.forEach(t=>{
			if(t.key === 'agent')t.options = agentList
		})
		this.modals.add.fields.forEach(t=>{
			if(t.key === 'cod_agent')t.options = agentList
		})
  },
  methods: {},
  data() {
    let that = this;
    return {
			agentList:[],
			configs:{},
			client:[],
			companies:[],
			unit:[],
			bubble:[],
			currencyList:[],
			SubjectCost:[],
      methods: {
        list(params){
					return getList(params)
				},
        add,
				uploadFile
      },
      modals: {
				upload: {
				  methods: {
				    ok() {
				      window.open(
				        this.$globalUrl + "/excel/tmp/shipmentCodAgentTpl.xlsx"
				      );
				    }
				  },
				  footer: {
				    cancel: {
				      isShow: true
				    },
				    ok: {
				      name: this.$t("download_tem")
				    }
				  },
				  config: {
				    modalBind: {
				      width: 500,
				      draggable: true,
				      maskClosable: false
				    },
				    rowBind: {
				      gutter: 16
				      // style: {
				      //   marginBottom: "20px"
				      // }
				    },
				    title: this.$t("upload") + this.$t("files")
				  },
				  grid: [{ files: 24 }],
				  fields: [
				    {
				      key: "files",
				      component: "Upload",
				      bind: {
				        type: "drag",
				        accept: ".xlsx"
				      },
				      methods: {
				        beforeUpload: ({ file }) => {
				          let formData = new FormData();
				          formData.append("file", file); // 文件对象
				          let _this = this.$refs["table"];
				          _this
				            .handleRequestMethods("uploadFile", formData)
				            .then(res => {
				              _this.$Message["success"]({
				                background: true,
				                content: res.msg
				              });
				              _this.getModal("upload").close();
				            });
				          return false;
				        }
				      }
				    }
				  ]
				},
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
							row.details = this.list
              this.$page.handleRequestMethods('add', row, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
							cod_agent: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							airway_number_list: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
            },
          },
          grid: [
            {cod_agent:24},
            {airway_number_list:24},
            {remarks:24},
          ],
          fields: [
						{
						  name: this.$t("order_number"),
						  key: "airway_number_list",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("order_number"),
						  bind: {
						    type: "textarea",
						    rows: 3
						  }
						},
						{
						  name: this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("Remarks"),
						  bind: {
						    type: "textarea",
						    rows: 3
						  }
						},
            {
              key: "cod_agent",
              name: () => this.$t("agentT"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("agentT")
                );
              },
              options: [],
							
							config:{
								label:'agent_name',
								value:'agent_name'
							},
            },
          ],
        },
      },
      header: {
        searchs: [
					{
					  key: "start_time",
					  component: "DatePicker",
					  placeholder() {
					    return (
					      this.$t("select") +
					      this.$t("start") +
					      this.$t("date") +
					      this.$t("time")
					    );
					  },
					  bind: {
					    type: "datetime",
					    options: {
					      disabledDate(time) {
					        // return time.getTime() > Date.now();
					        return false;
					      }
					    },
					    style: {
					      width: "175px"
					    }
					  },
					  methods: {
					    "on-change"({ searchForm }) {
					      searchForm.start_time = searchForm.start_time
					        ? this.$page.format.timeFormat(searchForm.start_time)
					        : "";
					    }
					  }
					},
					{
					  key: "end_time",
					  component: "DatePicker",
					  placeholder() {
					    return (
					      this.$t("select") +
					      this.$t("end") +
					      this.$t("date") +
					      this.$t("time")
					    );
					  },
					  bind: {
					    type: "datetime",
					    options: {
					      disabledDate(time) {
					        // return time.getTime() > Date.now();
					        return false;
					      }
					    },
					    style: {
					      width: "175px"
					    }
					  },
					  methods: {
					    "on-change"({ searchForm }) {
					      let time = this.$page.format.timeFormat(searchForm.end_time);
					      if (time.slice(-8) === "00:00:00") {
					        time = time.split(" ")[0] + " " + "23:59:59";
					        searchForm["end_time"] = time;
					      }
					    }
					  }
					},
					 {
						 key: "agent",
						 component: "Select",
						 placeholder() {
							 return this.$t("agentT");
						 },
						 clearable: true,
						 options: [],
						 bind: {
							 style: "width:140px"
						 },
						 config:{
						 	label:'agent_name',
						 	value:'agent_name'
						 },
				 },
          {
            key: "airway_number",
            placeholder() {
              return this.$t("Odd_Numbers");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              fnName: "add",
              type: "add",
              bind: {
                type: "primary",
              },
            },
						{
						  name: () => this.$t("import"),
						  fnName: "import",
						  type: "import",
						  bind: {
						    type: "primary",
						  },
						},
						{
							name: () => this.$t("export"),
							type: "export",
							fnName: "export",
							disabled() {
								return !this.selectAll.length;
							},
							bind: {
								icon: "md-arrow-down",
								type: "primary"
							}
						}
          ],
          methods: {
						export() {
						  this.exportExc();
						},
						import() {
						  this.getModal("upload").open();
						},
          	add(){
          		this.getModal('add').open({},function(){
          			this.setTitle(this.$t("add"));
          		})
          	},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
				{
				  name: this.$t("order_number"),
				  key: "airway_number",
				  minWidth: 120,
				},
				{
				  name: this.$t("original")+this.$t("agentT"),
				  key: "from_val",
				  minWidth: 120,
				},
				{
				  name: this.$t("newest")+this.$t("agentT"),
				  key: "to_val",
				  minWidth: 120,
				},
				{
				  name: this.$t("Remarks"),
				  key: "remarks",
				  minWidth: 120,
				},
				{
				  name: this.$t("operate"),
				  key: "operator_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("operation")+ this.$t('time'),
				  key: "create_time",
				  minWidth: 120,
				},
       /* {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
							// id:1258
            },
          ],
          methods: {
          },
        }, */
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
